import React, { useState } from "react";

const Stepper = ({ steps, currentStep ,setState,state,setFormData,formData,setInquiryType,schedule,setSchedule}) => {

  const handleCheckboxChange = (day, index) => {
    const updatedSchedule = { ...schedule };
    updatedSchedule[day][index] = !updatedSchedule[day][index];
    setSchedule(updatedSchedule);
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  return (
    <div className="mb-4">
      {steps
        ?.filter((step, index) => index === currentStep)
        .map((step, index) => (
          <div
            key={index}
            className={`step ${currentStep === index ? "active" : ""}`}
          >
            {/* <div>{step}</div> */}
            {step === "Step 1" && (
              <div>
                <div>
                  <p>Welcome to Our inquiry Form</p>
                  <p>
                    Please select the type of inquiry you would like to make
                    from the options below. Your selection will direct you to
                    the relevant section of the form.
                  </p>
                </div>

                <form className="d-flex flex-column gap-3">
                  <div className="input-container">
                    <label className="input-label" htmlFor="email">
                      Email address: <span className="require-star">*</span>
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      name="email"
                      id="email"
                      value={formData.email}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="input-container">
          <label className="input-label">
            Please select the type of inquiry you are making: <span className="require-star">*</span>
          </label>
          <div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="inquiryType"
                id="radio"
                checked={state}
                onChange={() => {
                  setState(true);
                  setInquiryType('Student Inquiry and Quotation Request Form');
                }}
              />
              <label className="form-check-label" htmlFor="radio">
                Student Inquiry and Quotation Request Form
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="inquiryType"
                id="flexRadioDefault2"
                checked={!state}
                onChange={() => {
                  setState(false);
                  setInquiryType('French Language Program Collaboration Inquiry');
                }}
              />
              <label className="form-check-label" htmlFor="flexRadioDefault2">
                French Language Program Collaboration Inquiry
              </label>
            </div>
          </div>
        </div>
                </form>
              </div>
            )}

{step === "Step 2" && state && (
              <div>
                <form className="d-flex flex-column gap-4">
                  <div className="input-container">
                    <label className="header-form">CONTACT PERSON INFORMATION</label>
                  </div>
                  <div className="input-container">
                    <label className="input-label" htmlFor="name">
                      Name of Contact Person: <span className="require-star">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="input-container">
                    <label htmlFor="contact" className="input-label">
                      Contact Number: <span className="require-star">*</span>
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      id="contact"
                      name="number"
                      value={formData.number}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="input-container">
                    <label htmlFor="name" className="input-label">
                      Relationship to Student: <span className="require-star">*</span>
                    </label>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="relationshipToStudent"
                        value="Same person"
                        checked={formData.relationshipToStudent === 'Same person'}
                        onChange={handleInputChange}
                      />
                      <label className="form-check-label" htmlFor="rs1">
                        Same person
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="relationshipToStudent"
                        value="Other"
                        checked={formData.relationshipToStudent === 'Other'}
                        onChange={handleInputChange}
                      />
                      <label className="form-check-label" htmlFor="rs2">
                        Other
                      </label>
                      {formData.relationshipToStudent === 'Other' && (
                        <input
                          type="text"
                          className="form-control"
                          name="otherRelationship"
                          value={formData.otherRelationship}
                          onChange={handleInputChange}
                        />
                      )}
                    </div>
                  </div>
                </form>
              </div>
            )}

{step === "Step 2" && !state && (
  <div>
    <div>
      <h5 className="fw-bold">
        FRENCH LANGUAGE PROGRAM COLLABORATION INQUIRY
      </h5>
      <p>
        At Your French Teachers, we bring a wealth of experience in teaching French to children aged 5 to 13 years. Our proven methodology encompasses the development of engaging curricula, detailed lesson plans, level assessments, and certificates, all tailored to create a dynamic and enjoyable learning environment. We emphasize a teaching style that blends fun with effectiveness, ensuring that students remain motivated and interested in learning the French language.
      </p>
      <p>
        Since September 2023, we have successfully collaborated with Stanford Canadian International School, where we currently instruct students from Grade 1 to Grade 6 at the SCIS Dagon Campus. Our approach involves dividing students into three age groups—5-7 years, 8-10 years, and 11-13 years—to align with their developmental stages and learning capabilities. This segmentation allows us to deliver age-appropriate instruction that maximizes their ability to absorb and apply new knowledge.
      </p>
      <p>
        Each of our sessions lasts for one hour, carefully designed to maintain student engagement and prevent fatigue. We strive to make the French language accessible, enjoyable, and appealing, ensuring that students perceive learning French as a rewarding and enjoyable experience.
      </p>
      <p>
        We are committed to fostering a positive and effective learning atmosphere and look forward to the opportunity to extend our expertise through future collaborations with international schools.
      </p>
    </div>

    <h5>CONTACT INFORMATION</h5>

    <form className="d-flex flex-column gap-4">
      <div className="input-container">
        <label htmlFor="campusName" className="input-label">
          Please provide the name of your school or campus:{" "}
          <span className="require-star">*</span>
        </label>
        <input
          type="text"
          className="form-control"
          id="campusName"
          name="campusName"
          value={formData.campusName}
          onChange={handleInputChange}
        />
      </div>

      <div className="input-container">
        <label htmlFor="campusAddress" className="input-label">
          School/Campus Address:{" "}
          <span className="require-star">*</span>
        </label>
        <input
          type="text"
          className="form-control"
          id="campusAddress"
          name="campusAddress"
          value={formData.campusAddress}
          onChange={handleInputChange}
        />
      </div>

      <div className="input-container">
        <label htmlFor="contactPersonName" className="input-label">
          Contact Person Name:{" "}
          <span className="require-star">*</span>
        </label>
        <input
          type="text"
          className="form-control"
          id="contactPersonName"
          name="contactPersonName"
          value={formData.contactPersonName}
          onChange={handleInputChange}
        />
      </div>

      <div className="input-container">
        <label htmlFor="contactEmail" className="input-label">
          Contact Email Address for Proposal Submissions:{" "}
          <span className="require-star">*</span>
        </label>
        <input
          type="email"
          className="form-control"
          id="contactEmail"
          name="contactEmail"
          value={formData.contactEmail}
          onChange={handleInputChange}
        />
      </div>

      <div className="input-container">
        <label className="input-label">
          Preferred Method of Contact:{" "}
          <span className="require-star">*</span>
        </label>
        <div className="form-check">
          <input
            className="form-check-input"
            type="radio"
            name="preferredContact"
            id="preferPhone"
            value="Phone"
            checked={formData.preferredContact === "Phone"}
            onChange={handleInputChange}
          />
          <label className="form-check-label" htmlFor="preferPhone">
            Phone
          </label>
        </div>

        <div className="form-check">
          <input
            className="form-check-input"
            type="radio"
            name="preferredContact"
            id="preferEmail"
            value="Email"
            checked={formData.preferredContact === "Email"}
            onChange={handleInputChange}
          />
          <label className="form-check-label" htmlFor="preferEmail">
            Email
          </label>
        </div>

        <div className="form-check">
          <input
            className="form-check-input"
            type="radio"
            name="preferredContact"
            id="preferEither"
            value="Either"
            checked={formData.preferredContact === "Either"}
            onChange={handleInputChange}
          />
          <label className="form-check-label" htmlFor="preferEither">
            Either
          </label>
        </div>
      </div>
    </form>
  </div>
)}


{step === "Step 3" && state && (
  <form className="d-flex flex-column gap-4">
    <div>
      <label className="header-form header-form2">
        2. INQUIRED STUDENT INFORMATION
      </label>
      <div className="input-container">
        <label htmlFor="name" className="input-label">
          Full Name of Student:{" "}
          <span className="require-star">*</span>
        </label>
        <input
          type="text"
          className="form-control"
          id="name"
          name="fullname"
          value={formData.fullname}
          onChange={handleInputChange}
        />
      </div>
    </div>

    <div className="input-container">
      <label htmlFor="age" className="input-label">
        Age of Student: <span className="require-star">*</span>
      </label>
      <input
        type="number"
        className="form-control"
        id="age"
        name="age"
        value={formData.age}
        onChange={handleInputChange}
      />
    </div>

    <div className="input-container">
      <label htmlFor="ageGroup" className="input-label">
        Please select the student's age group:{" "}
        <span className="require-star">*</span>
      </label>
      <div className="form-check">
        <input
          className="form-check-input"
          type="radio"
          name="ageGroup"
          id="rs1"
          value="5 to 7 years"
          checked={formData.ageGroup === "5 to 7 years"}
          onChange={handleInputChange}
        />
        <label className="form-check-label" htmlFor="rs1">
          5 to 7 years
        </label>
      </div>
      <div className="form-check">
        <input
          className="form-check-input"
          type="radio"
          name="ageGroup"
          id="rs2"
          value="11 to 13 years"
          checked={formData.ageGroup === "11 to 13 years"}
          onChange={handleInputChange}
        />
        <label className="form-check-label" htmlFor="rs2">
          11 to 13 years
        </label>
      </div>
      <div className="form-check">
        <input
          className="form-check-input"
          type="radio"
          name="ageGroup"
          id="rs3"
          value="Teenage (14 to 17 years)"
          checked={formData.ageGroup === "Teenage (14 to 17 years)"}
          onChange={handleInputChange}
        />
        <label className="form-check-label" htmlFor="rs3">
          Teenage (14 to 17 years)
        </label>
      </div>
      <div className="form-check">
        <input
          className="form-check-input"
          type="radio"
          name="ageGroup"
          id="rs4"
          value="Adult (18+ years)"
          checked={formData.ageGroup === "Adult (18+ years)"}
          onChange={handleInputChange}
        />
        <label className="form-check-label" htmlFor="rs4">
          Adult (18+ years)
        </label>
      </div>
      <div className="form-check">
        <input
          className="form-check-input"
          type="radio"
          name="ageGroup"
          id="rs5"
          value="Other"
          checked={formData.ageGroup === "Other"}
          onChange={handleInputChange}
        />
        <label className="form-check-label" htmlFor="rs5">
          Other
        </label>
       {
        formData.ageGroup ==="Other" && (
          <input
          className="form-control"
          type="text"
          name="ageGroupOther"
          value={formData.ageGroupOther || ""}
          onChange={handleInputChange}
        />
        )
       }
      </div>
    </div>

    <div className="input-container">
      <label htmlFor="level" className="input-label">
        Please select the level for which you would like to inquire:{" "}
        <span className="require-star">*</span>
      </label>
      <div className="form-check">
        <input
          className="form-check-input"
          type="radio"
          name="level"
          id="l1"
          value="Beginner (A1)"
          checked={formData.level === "Beginner (A1)"}
          onChange={handleInputChange}
        />
        <label className="form-check-label" htmlFor="l1">
          Beginner (A1)
        </label>
      </div>
      <div className="form-check">
        <input
          className="form-check-input"
          type="radio"
          name="level"
          id="l2"
          value="Elementary (A2)"
          checked={formData.level === "Elementary (A2)"}
          onChange={handleInputChange}
        />
        <label className="form-check-label" htmlFor="l2">
          Elementary (A2)
        </label>
      </div>
      <div className="form-check">
        <input
          className="form-check-input"
          type="radio"
          name="level"
          id="l3"
          value="Intermediate (B1)"
          checked={formData.level === "Intermediate (B1)"}
          onChange={handleInputChange}
        />
        <label className="form-check-label" htmlFor="l3">
          Intermediate (B1)
        </label>
      </div>
      <div className="form-check">
        <input
          className="form-check-input"
          type="radio"
          name="level"
          id="l4"
          value="Upper Intermediate (B2)"
          checked={formData.level === "Upper Intermediate (B2)"}
          onChange={handleInputChange}
        />
        <label className="form-check-label" htmlFor="l4">
          Upper Intermediate (B2)
        </label>
      </div>
    </div>

    <div className="input-container">
      <label htmlFor="interested-course" className="input-label">
        Which course are you interested in?{" "}
        <span className="require-star">*</span>
      </label>
      <div className="form-check">
        <input
          className="form-check-input"
          type="radio"
          name="course"
          id="rs11"
          value="French Language Course (A1 to B2)"
          checked={formData.course === "French Language Course (A1 to B2)"}
          onChange={handleInputChange}
        />
        <label className="form-check-label" htmlFor="rs11">
          French Language Course (A1 to B2)
        </label>
      </div>
      <div className="form-check">
        <input
          className="form-check-input"
          type="radio"
          name="course"
          id="rs22"
          value="DELF/DALF Exam Preparation Course"
          checked={formData.course === "DELF/DALF Exam Preparation Course"}
          onChange={handleInputChange}
        />
        <label className="form-check-label" htmlFor="rs22">
          DELF/DALF Exam Preparation Course
        </label>
      </div>
      <div className="form-check">
        <input
          className="form-check-input"
          type="radio"
          name="course"
          id="rs33"
          value="TCF/TEF Exam Preparation Course"
          checked={formData.course === "TCF/TEF Exam Preparation Course"}
          onChange={handleInputChange}
        />
        <label className="form-check-label" htmlFor="rs33">
          TCF/TEF Exam Preparation Course
        </label>
      </div>
      <div className="form-check">
        <input
          className="form-check-input"
          type="radio"
          name="course"
          id="rs44"
          value="IGCSE French Course"
          checked={formData.course === "IGCSE French Course"}
          onChange={handleInputChange}
        />
        <label className="form-check-label" htmlFor="rs44">
          IGCSE French Course
        </label>
      </div>
      <div className="form-check">
        <input
          className="form-check-input"
          type="radio"
          name="course"
          id="rs55"
          value="Personalized Course for Other Study Purpose"
          checked={formData.course === "Personalized Course for Other Study Purpose"}
          onChange={handleInputChange}
        />
        <label className="form-check-label" htmlFor="rs55">
          Personalized Course for Other Study Purpose (e.g., Business, Tourism, Fashion)
        </label>
      </div>
      <div className="form-check">
        <input
          className="form-check-input"
          type="radio"
          name="course"
          id="r66"
          value="Other"
          checked={formData.course === "Other"}
          onChange={handleInputChange}
        />
        <label className="form-check-label" htmlFor="r66">
          Other
        </label>
       { 
        formData.course ==="Other" && (
          <input
          className="form-control"
          type="text"
          name="courseOther"
          value={formData.courseOther || ""}
          onChange={handleInputChange}
        />
        )
       }
      </div>
    </div>

    <div className="input-container">
      <label htmlFor="number-of-students" className="input-label">
        Number of Students (Please specify the number of participants if enrolling more than one student.){" "}
        <span className="require-star">*</span>
      </label>
      <input
        type="number"
        className="form-control"
        id="number-of-students"
        name="numberOfStudents"
        placeholder="Your answer"
        value={formData.numberOfStudents || ""}
        onChange={handleInputChange}
      />
    </div>

   
  </form>
)}

            {step === "Step 3" && !state && (
              <div>
                <div>
                  <h5 className="fw-bold">PROGRAM DETAILS</h5>
                </div>

                <form className="d-flex flex-column gap-4">
                  <div className="input-container">
                    <label htmlFor="number" className="input-label">
                      Please specify the number of students per course.{" "}
                      <span className="require-star">*</span>
                    </label>
                    <input type="number" className="form-control" id="number" 
                    name="prenumberofStudent"
                    value={formData.prenumberOfStudent}
                    onChange={handleInputChange}/>
                  </div>
                  <div className="input-container">
                    <label className="input-label">
                      Age Groups of Students:{" "}
                      <span className="require-star">*</span>
                    </label>

                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        defaultValue
                        id="age-groups-of-students-1"
                        name="ageGroup"
         
                        value="5 to 7 years"
                        checked={formData.ageGroup === "5 to 7 years"}
                        onChange={handleInputChange}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="age-groups-of-students-1"
                      >
                        5 to 7 years
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="age-groups-of-students-2"
                          name="ageGroup"
                        value="8 to 10 years"
                        checked={formData.ageGroup === "8 to 10 years"}
                        onChange={handleInputChange}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="age-groups-of-students-2"
                      >
                        8 to 10 years
                      </label>
                    </div>

                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="age-groups-of-students-3"
                        value="11 to 13 years"
                          name="ageGroup"
                        checked={formData.ageGroup === "11 to 13 years"}
                        onChange={handleInputChange}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="age-groups-of-students-3"
                      >
                        11 to 13 years
                      </label>
                    </div>

                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="age-groups-of-students-4"
                        value="Teenage (14 to 17 years)"
                          name="ageGroup"
                        checked={formData.ageGroup === "Teenage (14 to 17 years)"}
                        onChange={handleInputChange}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="age-groups-of-students-4"
                      >
                        Teenage (14 to 17 years)
                      </label>
                    </div>

                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="age-groups-of-students-5"
                        value="Adult (18+ years)"
                        name="ageGroup"
                      checked={formData.ageGroup === "Adult (18+ years)"}
                      onChange={handleInputChange}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="age-groups-of-students-5"
                      >
                        Adult (18+ years)
                      </label>
                    </div>
                  </div>
                  <div className="input-container">
                    <label className="input-label">
                      Current French Proficiency Levels of Students:{" "}
                      <span className="require-star">*</span>
                    </label>

                    <form className="d-flex flex-column gap-4">
                      <div>
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                           
                            id="cfpl1"
                            name="level"
                           
                            value="0 Level"
                            checked={formData.level === "0 Level"}
                            onChange={handleInputChange}
                          />
                          <label className="form-check-label" htmlFor="cfpl1">
                            0 Level
                          </label>
                        </div>
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            
                            id="cfpl2"
                            name="level"
                           
                            value="Beginner (A1)"
                            checked={formData.level === "Beginner (A1)"}
                            onChange={handleInputChange}
                          />
                          <label className="form-check-label" htmlFor="cfpl2">
                            Beginner (A1)
                          </label>
                        </div>
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                           
                            id="cfpl3"
                            name="level"
                           
                            value="Elementary (A2)"
                            checked={formData.level === "Elementary (A2)"}
                            onChange={handleInputChange}
                          />
                          <label className="form-check-label" htmlFor="cfpl3">
                            Elementary (A2)
                          </label>
                        </div>
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            
                            id="cfpl4"
                            name="level"
                           
                            value="Intermediate (B1)"
                            checked={formData.level === "Intermediate (B1)"}
                            onChange={handleInputChange}
                          />
                          <label className="form-check-label" htmlFor="cfpl4">
                            Intermediate (B1)
                          </label>
                        </div>
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                           
                            id="cfpl4"
                            name="level"
                           
                            value="Upper Intermediate (B2)"
                            checked={formData.level === "Upper Intermediate (B2)"}
                            onChange={handleInputChange}
                          />
                          <label className="form-check-label" htmlFor="cfpl4">
                            Upper Intermediate (B2)
                          </label>
                        </div>
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                          
                            id="cfpl5"
                            name="level"
                           
                            value="Advanced (C1/C2)"
                            checked={formData.level === "Advanced (C1/C2)"}
                            onChange={handleInputChange}
                          />
                          <label className="form-check-label" htmlFor="cfpl5">
                            Advanced (C1/C2)
                          </label>
                        </div>
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                           
                            id="cfpl6"
                            name="level"
                           
                            value="Mixed Levels"
                            checked={formData.level === "Mixed Levels"}
                            onChange={handleInputChange}
                          />
                          <label className="form-check-label" htmlFor="cfpl6">
                            Mixed Levels
                          </label>
                        </div>
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                           
                            id="cfpl7"
                            name="level"
                           
                            value="Other"
                            checked={formData.level === "Other"}
                            onChange={handleInputChange}
                          />
                          <label className="form-check-label" htmlFor="cfpl7">
                            Other:
                          </label>
                          <input type="text" className="form-control" 
                            name="level"
                            onChange={handleInputChange}
                            />
                        </div>
                      </div>
                    </form>
                  </div>
                  <div className="input-container">
                    <label className="input-label">
                      Preferred Number of Sessions Per Week:{" "}
                      <span className="require-star">*</span>
                    </label>
                    <div>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          
                          id="pnos1"
                          name="week"
                          value="1 session per week"
                            checked={formData.week === "1 session per week"}
                            onChange={handleInputChange}
                        />
                        <label className="form-check-label" htmlFor="pnos1">
                          1 session per week
                        </label>
                      </div>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="week"
                          value="2 session per week"
                            checked={formData.week === "2 session per week"}
                            onChange={handleInputChange}
                          id="pnos2"
                        />
                        <label className="form-check-label" htmlFor="pnos2">
                          2 sessions per week
                        </label>
                      </div>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="week"
                          value="3 session per week"
                            checked={formData.week === "3 session per week"}
                            onChange={handleInputChange}
                          id="pnos3"
                        />
                        <label className="form-check-label" htmlFor="pnos3">
                          3 sessions per week
                        </label>
                      </div>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="week"
                          value="4 session per week"
                            checked={formData.week === "4 session per week"}
                            onChange={handleInputChange}
                          id="pnos4"
                        />
                        <label className="form-check-label" htmlFor="pnos4">
                          4 sessions per week
                        </label>
                      </div>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="week"
                          value="Other"
                            checked={formData.week === "Other"}
                            onChange={handleInputChange}
                          id="pnos5"
                        />
                        <label className="form-check-label" htmlFor="pnos5">
                          Other:
                        </label>
                        {
                          formData.week ==="Other" && (
                            <input type="text" className="form-control"
                          name="weekOther"
                          value={formData.weekOther}
                          onChange={handleInputChange}
                           />
                          )
                        }
                      </div>
                    </div>
                  </div>
                  <div className="input-container">
                    <label className="input-label">
                      Preferred Course Duration:{" "}
                      <span className="require-star">*</span>
                    </label>
                    <form className="d-flex flex-column gap-4">
                      <div>
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="duration"
                            value="1 session per week"
                              checked={formData.duration === "1 session per week"}
                              onChange={handleInputChange}
                            id="pcd1"
                          />
                          <label className="form-check-label" htmlFor="pcd1">
                            1 session per week
                          </label>
                        </div>
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="duration"
                            value="2 session per week"
                              checked={formData.duration === "2 session per week"}
                              onChange={handleInputChange}
                            id="pcd2"
                          />
                          <label className="form-check-label" htmlFor="pcd2">
                            2 sessions per week
                          </label>
                        </div>
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="duration"
                            value="3 session per week"
                              checked={formData.duration === "3 session per week"}
                              onChange={handleInputChange}
                            id="pcd3"
                          />
                          <label className="form-check-label" htmlFor="pcd3">
                            3 sessions per week
                          </label>
                        </div>
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="duration"
                            value="4 session per week"
                              checked={formData.duration === "4 session per week"}
                              onChange={handleInputChange}
                            id="pcd4"
                          />
                          <label className="form-check-label" htmlFor="pcd4">
                            4 sessions per week
                          </label>
                        </div>
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="duration"
                            value="Other"
                              checked={formData.duration === "Other"}
                              onChange={handleInputChange}
                            id="pcd5"
                          />
                          <label className="form-check-label" htmlFor="pcd5">
                            Other:
                          </label>
                         {
                          formData.duration ==="Other" && (
                            <input type="text" className="form-control" value={formData.durationOther} name="durationOther"  onChange={handleInputChange}/>
                          )
                         }
                        </div>
                      </div>
                    </form>
                  </div>
                </form>
              </div>
            )}

            {step === "Step 4" && state && (
              <div>
                <form className="d-flex flex-column gap-4">
                  <div>
                    <label className="header-form header-form2">
                      COURSE PREFERENCES
                    </label>
                    <div className="input-container">
                      <label className="input-label">
                        Preferred Learning Schedule:{" "}
                        <span className="fw-normal">
                          (Please select your preferred days and times for the
                          course.)
                        </span>
                      </label>
                      <div className="learning-schedule">
      <div className="row">
        <label className="col day"></label>
        <div className="col">
          <label className="text-label">Morning (9 - 12)</label>
        </div>
        <div className="col">
          <label className="text-label">Afternoon (12 - 4)</label>
        </div>
        <div className="col">
          <label className="text-label">Evening (4 - 7)</label>
        </div>
        <div className="col">
          <label className="text-label">Night (7 - 11)</label>
        </div>
      </div>
      <div className="row-container">
        {/* Days of the week */}
        {['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'].map((day) => (
          <div className="row schedule" key={day}>
            <label className="col day">{day.charAt(0).toUpperCase() + day.slice(1)}</label>
            {[0, 1, 2, 3].map((index) => (
              <div className="col d-flex justify-content-center" key={index}>
                <input
                  className="form-check-input"
                  type="checkbox"
                  name={`${day}-schedule`}
                  id={`${day}${index + 1}`}
                  checked={schedule[day][index]}
                  onChange={() => handleCheckboxChange(day, index)}
                />
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
                    </div>
                  </div>
                  <div className="input-container">
                    <label className="input-label">
                      Preferred Course Duration:{" "}
                      <span className="require-star">*</span>
                    </label>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="duration"
                        value="1 Month"
                        checked={formData.duration === "1 Month"}
                        onChange={handleInputChange}
                        id="pc1"
                        
                      />
                      <label className="form-check-label" htmlFor="pc1">
                        1 Month
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="duration"
                        value="3 Month"
                        checked={formData.duration === "3 Month"}
                        onChange={handleInputChange}
                        id="pc2"
                      />
                      <label className="form-check-label" htmlFor="pc2">
                        3 Months
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="duration"
                        value="6 Month"
                        checked={formData.duration === "6 Month"}
                        onChange={handleInputChange}
                        id="pc3"
                      />
                      <label className="form-check-label" htmlFor="pc3">
                        6 Months
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="duration"
                        value="12 Month"
                        checked={formData.duration === "12 Month"}
                        onChange={handleInputChange}
                        id="pc4"
                      />
                      <label className="form-check-label" htmlFor="pc4">
                        12 Months
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="duration"
                        value="If satisfied with our teaching, the student may continue
                        the course until reaching the desired level of French."
                        checked={formData.duration === "If satisfied with our teaching, the student may continue the course until reaching the desired level of French"}
                        onChange={handleInputChange}
                        id="pc5"
                      />
                      <label className="form-check-label" htmlFor="pc5">
                        If satisfied with our teaching, the student may continue
                        the course until reaching the desired level of French.
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="duration"
                        value="Other"
                        checked={formData.duration === "Other"}
                        onChange={handleInputChange}
                        id="pc6"
                      />
                      <label className="form-check-label" htmlFor="pc6">
                        Other
                      </label>
                      {
                          formData.duration ==="Other" && (
                            <input type="text" className="form-control" value={formData.durationOther} name="durationOther"  onChange={handleInputChange}/>
                          )
                         }
                    </div>
                  </div>
                  <div className="input-container">
                    <label className="input-label">
                      Learning Mode: <span className="require-star">*</span>
                    </label>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="learning"
                       
                        value="Online"
                        checked={formData.learning === "Online"}
                        onChange={handleInputChange}
                        id="lm1"
                        
                      />
                      <label className="form-check-label" htmlFor="lm1">
                        Online
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="learning"
                       
                        value="In-Person"
                        checked={formData.learning === "In-Person"}
                        onChange={handleInputChange}
                        id="lm2"
                      />
                      <label className="form-check-label" htmlFor="lm2">
                        In-Person
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="learning"
                       
                        value="Hybrid (Online + In-Person)"
                        checked={formData.learning === "Hybrid (Online + In-Person)"}
                        onChange={handleInputChange}
                        id="lm3"
                      />
                      <label className="form-check-label" htmlFor="lm3">
                        Hybrid (Online + In-Person)
                      </label>
                    </div>
                  </div>
                </form>
              </div>
            )}

            {step === "Step 4" && !state && (
              <div>
                <div>
                  <h5 className="fw-bold">SCOPE OF COLLABORATION</h5>
                </div>

                <form className="d-flex flex-column gap-4">
                  <div className="input-container">
                    <label className="input-label">
                      Type of Support Required:{" "}
                      <span className="require-star">*</span>
                    </label>
                    <div>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="require"
                        value="Teaching only (using your school's existing curriculum
                          and materials)"
                        checked={formData.require === "Teaching only (using your school's existing curriculum and materials)"}
                        onChange={handleInputChange}
                          id="tsr1"
                        />
                        <label className="form-check-label" htmlFor="tsr1">
                          Teaching only (using your school's existing curriculum
                          and materials)
                        </label>
                      </div>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="require"
                        value="Full program management (including curriculum
                          development, lesson planning, assessments, report
                          cards, certificates, etc.)"
                        checked={formData.require === "Full program management (including curriculum development, lesson planning, assessments, report cards, certificates, etc.)"}
                        onChange={handleInputChange}
                          id="tsr2"
                        />
                        <label className="form-check-label" htmlFor="tsr2">
                          Full program management (including curriculum
                          development, lesson planning, assessments, report
                          cards, certificates, etc.)
                        </label>
                      </div>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="require"
                          value="Other"
                          checked={formData.require === "Other"}
                          onChange={handleInputChange}
                          id="tsr3"
                        />
                        <label className="form-check-label" htmlFor="tsr3">
                          Other
                        </label>
                        {
                          formData.require ==="Other" && (
                            <input type="text" className="form-control" value={formData.requireOther} name="requireOther"  onChange={handleInputChange}/>
                          )
                         }
                      </div>
                    </div>
                  </div>
                  <div className="input-container">
                    <label
                      className="input-label"
                      htmlFor="additional-requirements"
                    >
                      Additional Requirements or Information:{" "}
                      <span className="require-star">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="additional-requirements"
                      placeholder="Your answer"
                      name="question"
                      value={formData.question}
                     
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="input-container">
                    <label
                      className="input-label"
                      htmlFor="additional-comments"
                    >
                      Additional Comments or Questions:{" "}
                      <span className="require-star">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="additional-comments"
                      placeholder="Your answer"
                      name="comment"
                      value={formData.comment}
                     
                      onChange={handleInputChange}
                    />
                  </div>
                </form>
              </div>
            )}

{step === "Step 5" && state && (
  <div>
    <div>
      <h5 className="fw-bold">ADDITIONAL INFORMATION</h5>
    </div>
    <form className="d-flex flex-column gap-4">
      {/* Specific Learning Goals or Requirements */}
      <div className="input-container">
        <label htmlFor="goals" className="input-label">
          Specific Learning Goals or Requirements: (Please describe any specific goals, areas of focus, or requirements you have for the course.){" "}
          <span className="require-star">*</span>
        </label>
        <input
          className="form-control"
          type="text"
          id="goals"
          placeholder="your answer"
          name="goal"
          value={formData.goal}
          onChange={handleInputChange}
        />
      </div>

      {/* How did you hear about YFT */}
      <div className="input-container">
        <label className="input-label">
          How did you hear about Your French Teachers?{" "}
          <span className="require-star">*</span>
        </label>
        {["YFT Programs and Events", "Learn French with Yonn", "Social Media", "Social Media Recommendation", "Referral from a Friend", "Google Search", "Advertisement"].map((option, index) => (
          <div className="form-check" key={index}>
            <input
              className="form-check-input"
              type="radio"
              id={`h${index + 1}`}
              name="hear"
              value={option}
              checked={formData.hear === option}
              onChange={handleInputChange}
            />
            <label className="form-check-label" htmlFor={`h${index + 1}`}>
              {option}
            </label>
          </div>
        ))}
        
        {/* Other Option */}
        <div className="form-check">
          <input
            className="form-check-input"
            type="radio"
            id="h8"
            name="hear"
            value="Other"
            checked={formData.hear === "Other"}
            onChange={handleInputChange}
          />
          <label className="form-check-label" htmlFor="h8">
            Other
          </label>
          {formData.hear === "Other" && (
            <input
              className="form-control"
              type="text"
              name="hearOther"
              value={formData.hearOther}
              onChange={handleInputChange}
              placeholder="Please specify"
            />
          )}
        </div>
      </div>

      {/* Would you like to receive updates and promotional offers */}
      <div className="input-container">
        <label className="input-label">
          Would you like to receive updates and promotional offers from Your French Teachers?{" "}
          <span className="require-star">*</span>
        </label>
        {["Yes", "No"].map((option, index) => (
          <div className="form-check" key={index}>
            <input
              className="form-check-input"
              type="radio"
              id={`u${index + 1}`}
              name="updates"
              value={option}
              checked={formData.updates === (option === "Yes" ? "true":"false")}
              onChange={(e)=>setFormData((prevData) => ({
                ...prevData,
                [e.target.name]: e.target.value ==="Yes" ? "true":"false",
              }))}
            />
            <label className="form-check-label" htmlFor={`u${index + 1}`}>
              {option}
            </label>
          </div>
        ))}
      </div>

      {/* Preferred Method of Contact */}
      <div className="input-container">
        <label className="input-label">
          Preferred Method of Contact:{" "}
          <span className="require-star">*</span>
        </label>
        {["Phone", "Email", "Either"].map((option, index) => (
          <div className="form-check" key={index}>
            <input
              className="form-check-input"
              type="radio"
              id={`prefer${index + 1}`}
              name="prefer"
              value={option}
              checked={formData.prefer === option}
              onChange={handleInputChange}
            />
            <label className="form-check-label" htmlFor={`prefer${index + 1}`}>
              {option}
            </label>
          </div>
        ))}
      </div>

      <div className="input-container">
        <label className="fw-bold">
          Submit Your Inquiry and Quotation Request!
        </label>
      </div>
    </form>
  </div>
)}

          </div>
        ))}
    </div>
  );
};

export default Stepper;